import { createEvent, createStore } from 'effector'
import Certificate, { PaymentProps } from './types'

export const routeToPage = createEvent<string>()
export const setCertificateStore = createEvent<Certificate>()
export const setPaymentInfo = createEvent<PaymentProps>()

export const pageStore = createStore('home').on(routeToPage, (_, value) => value)
export const certificateStore = createStore<Certificate | null>(null).on(setCertificateStore, (_, value) => value)
export const paymentStore = createStore<any | null>(null).on(setPaymentInfo, (_, value) => value)
